// extracted by mini-css-extract-plugin
export default {"root":"_2tO3G","link-overlay":"_1l89n","linkOverlay":"_1l89n"};